import { useState } from 'react'
import { Citation } from '@deepguide-ai/types'
import { Button } from '@deepguide-ai/ui/button'
import { Separator } from '@deepguide-ai/ui/separator'
import { UIMessagePart, UIDataTypes, UITools } from 'ai'
import { ChevronUp, Search } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { Streamdown } from 'streamdown'
import { cn } from '@/lib/utils'
import NoResults from './NoResults'

const SearchKnowledgeMessage = ({
  part,
}: {
  part: UIMessagePart<UIDataTypes, UITools>
}) => {
  const [showDetails, setShowDetails] = useState(false)

  let citations: Citation[] | null = null
  // console.log("SearchKnowledgeMessage", part, icon)
  if (part.state === 'output-available') {
    try {
      citations = JSON.parse(part?.output)
    } catch (_error) {
      // ignore
    }
  }
  const query: string | null = part?.input?.query ?? null
  return (
    <div className='flex w-full flex-col items-start gap-0 rounded-md border'>
      <Button
        variant='ghost'
        className='group/icon inline-flex h-auto w-full min-w-16 items-center justify-start gap-2 bg-transparent py-2.5 hover:bg-transparent'
        onClick={() => setShowDetails(!showDetails)}
      >
        {/* <div className='text-muted-foreground flex w-4 shrink-0 items-center justify-center'>
          <div></div>
        </div> */}
        <Search size={20} strokeWidth={2} />

        <span
          className={cn(
            'text-foreground flex-1 text-left text-[14px] font-medium tracking-[0] break-words whitespace-normal'
          )}
        >
          {part.state === 'output-available'
            ? `Found ${citations?.length} ${
                citations?.length === 1 ? 'topic' : 'topics'
              } on "${query}"`
            : `Searching existing knowledge on "${query}"...`}
        </span>
        <ChevronUp
          className={cn('size-4 transition-transform duration-300', {
            'rotate-180': !showDetails,
          })}
          strokeWidth={2}
        />
      </Button>
      {showDetails && <Separator className='my-0' />}
      <AnimatePresence>
        {showDetails && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{
              height: { duration: 0.2, ease: [0.23, 1, 0.32, 1] },
              opacity: { duration: 0.15 },
            }}
            className='w-full overflow-hidden'
          >
            <div className='text-muted-foreground flex w-full flex-col items-start gap-2 px-4 py-3 text-sm'>
              {citations?.length ? (
                citations?.map((citation) => (
                  <div key={citation.id} className='mb-2'>
                    <h3 className='text-foreground font-semibold'>
                      {citation.title}
                    </h3>
                    <div className='streamdown-custom [&_div]:!my-0 [&_h1]:!my-2 [&_h2]:!my-2 [&_h3]:!my-2 [&_h4]:!my-2 [&_h5]:!my-2 [&_h6]:!my-2 [&_p]:!mb-0'>
                      <Streamdown>
                        {(citation.content ?? '')?.slice(0, 200)}
                      </Streamdown>
                    </div>
                  </div>
                ))
              ) : (
                <NoResults />
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default SearchKnowledgeMessage
